import * as React from "react";
import { Link } from "react-router-dom";
import { styled } from "styled-components";

import { CheckboxField } from "affinityForm/fields";
import { ConsentHistoryInfoText } from "affinityUI/data/valueDisplay/patientConsent/consentHistoryInfoText";
import { DataEntryGroup } from "affinityUI/form/components";
import { PreviousPatientDataContext } from "components/pages/patients/editPatient";

export const Separator = styled.hr`
  border-top: ${(props) => props.theme.colours.borders};
  margin: 0 0 2rem 0;
`;

export const SectionPatientConsent: React.FC = () => {
  const previousPatientData = React.useContext(PreviousPatientDataContext) ?? undefined;

  return (
    <DataEntryGroup title="Consent" id="consent">
      <CheckboxField name="consent.service">
        Patient consents to use Liberty service
        <ConsentHistoryInfoText lastUpdated={{ ...previousPatientData?.consent?.serviceLastUpdate?.[0] }} />
      </CheckboxField>
      <CheckboxField name="consent.privacyPolicy">
        Patient consents to share data according to the{" "}
        <Link target="_blank" to="https://www.libertycareportal.co/privacy-policy">
          Privacy Policy
        </Link>
        <ConsentHistoryInfoText lastUpdated={{ ...previousPatientData?.consent?.privacyPolicyLastUpdate?.[0] }} />
      </CheckboxField>
      <CheckboxField name="consent.feedback">
        Patient consents to be contacted for feedback
        <ConsentHistoryInfoText lastUpdated={{ ...previousPatientData?.consent?.feedbackLastUpdate?.[0] }} />
      </CheckboxField>
      <CheckboxField name="consent.research">
        Patient consents to be contacted for research purposes
        <ConsentHistoryInfoText lastUpdated={{ ...previousPatientData?.consent?.researchLastUpdate?.[0] }} />
      </CheckboxField>
    </DataEntryGroup>
  );
};
